import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../shared/services/apiService.service'
import { NgxSpinnerService } from 'ngx-spinner';
import { RootService } from  '../../../shared/services/root.service'
import { BehaviourSubjectService } from  '../../../shared/services/behaviour-subject.service'
import { secureStorage } from '../../../shared/services/encryption/secureservice';


@Component({
  selector: 'app-reward-gift-card',
  templateUrl: './reward-gift-card.component.html',
  styleUrls: ['./reward-gift-card.component.scss'],
})
export class RewardGiftCardComponent implements OnInit {
  sub: Subscription = new Subscription();
  balance: number = 0;
  options: number[] = [250, 500, 1000, 2000];
  selectedQuantities: { [key: number]: number } = {};
  totalSelected: number = 0;
  height: number = 0;
  width: number = 0;
  isMobile: boolean = false;
  environment1 = environment.s3bucket.url;
  showAlert: boolean = false;
  showLoader: any = false;
  userData: any;
  userRedemptionData: any;
  userBalance: any;
  totalBurnValue: any;
  storedReward: any;
  currentRoute: any;
  constructor(
    private router: Router,
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private secureService: RootService,
    private behaviorService: BehaviourSubjectService,
    private localStorage: secureStorage,


    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.height = window.innerHeight;
      this.width = window.innerWidth;
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
      this.userData = this.secureService.getUserData();
      if (isPlatformBrowser(this.platformId)) {
      this.userBalance = JSON.parse(this.localStorage.getItem('userBalLocalSto'));
      this.storedReward = JSON.parse(this.localStorage.getItem('rewardData'));
      this.options.forEach((option) => (this.selectedQuantities[option] = 0));
      this.getLoyalityUserBalance();
      localStorage.removeItem('currentRoute');
      localStorage.removeItem('rewardTermsCondition');
      }
    this.currentRoute = this.router.url;
    }
  }

  getQuantity(option: number): number {
    return this.selectedQuantities[option] ?? 0;
  }

  decrease(option: number) {
    if (this.selectedQuantities[option] > 0) {
      this.selectedQuantities[option]--;
      this.totalSelected -= option;

      if (this.totalSelected + option <= this.balance) {
        this.showAlert = false;
      }
    }
  }

  increase(option: number) {
    if (this.totalSelected + option <= this.balance) {
      if (!this.selectedQuantities[option]) {
        this.selectedQuantities[option] = 0;
      }
      this.selectedQuantities[option]++;
      this.totalSelected += option;
      this.showAlert = false;
    } else {
      this.showAlert = true;
    }
  }

  redeem() {
    if (this.totalSelected > 0) {
      if (this.balance >= this.totalSelected) {
        const filteredQuantities = Object.entries(this.selectedQuantities)
          .filter(([key, value]) => value > 0)
          .reduce((obj, [key, value]) => {
            obj[key] = value;
            return obj;
          }, {});
          if (isPlatformBrowser(this.platformId)) {
        this.localStorage.setItem('totalSelected', JSON.stringify(this.totalSelected ));
          }
        const data = {
          mobile_number: this.userData.mobile_number,
          points: this.totalSelected,
          source: 'OSP',
          product_name: this.storedReward.product,
          quantity: filteredQuantities,
          sku: this.storedReward.sku,
        };

        this.spinner.show();
        this.showLoader = true;

        try {
          this.sub.add(
            this.apiService.addLoyalityRedemption(data).subscribe({
              next: (res) => {
                this.spinner.hide();
                if (res.success) {
                  this.userRedemptionData = res.data;
                  this.balance -= this.totalSelected;
                  this.totalBurnValue += this.totalSelected
                  this.userBalance.total_burn = this.totalBurnValue
                  // this.localStorage.setItem('userBalLocalSto', this.userBalance )
                  if (isPlatformBrowser(this.platformId)) {
                  this.localStorage.setItem('userBalLocalSto', JSON.stringify(this.userBalance));
                  }
                  this.selectedQuantities = {};
                  this.totalSelected = 0;
                  this.behaviorService.loyalityUserBalance.next(this.balance);
                  this.getUserbalByLocal()
                  this.router.navigate(['/account/reward-statement'], {
                    queryParams: { step: 1 },
                  });
                } else {
                  if (res.data.status === 'PROCESSING') {
                    this.balance -= this.totalSelected;
                    this.selectedQuantities = {};
                    this.totalSelected = 0;
                    this.behaviorService.loyalityUserBalance.next(this.balance);
                    this.getUserbalByLocal()
                    this.router.navigate(['/account/reward-statement'], {
                      queryParams: { step: 2 },
                    });
                  } else {
                    this.router.navigate(['/account/reward-statement'], {
                      queryParams: { step: 3 },
                    });
                  }
                }
              },
              error: (error) => {
                this.spinner.hide();
              },
              complete: () => {
                this.spinner.hide();
              },
            })
          );
        } catch (error) {
          this.spinner.hide();
        }
      } else {
      }
    } else {

    }
  }

  getUserbalByLocal(){
    if (this.userBalance?.user_balance_list && this.userBalance.user_balance_list[0]) {
      this.userBalance.user_balance_list[0].current_balance = this.balance;
    } else {
      console.error('user_balance_list or the first item does not exist.');
    }
    if (isPlatformBrowser(this.platformId)) {
    this.localStorage.setItem('userBalLocalSto', JSON.stringify(this.userBalance));
    }
  }


  getLoyalityUserBalance() {
    const data = {
      mobile_number: this.userData.mobile_number,
      source: 'OSP',
    };
    try {
      this.spinner.show();
      this.showLoader = true;

      this.sub.add(
        this.apiService.getUserBalance(data).subscribe({
          next: (res) => {
            if (res.success) {
              this.spinner.hide();
              this.showLoader = false;
              this.userBalance = res.data;
              this.balance =
                this.userBalance.user_balance_list[0]?.current_balance;
                this.totalBurnValue = this.userBalance.total_burn
            } else {
            }
            this.spinner.hide();
          },
          error: (err) => {
            this.spinner.hide();
          },
          complete: () => {
            this.spinner.hide();
          },
        })
      );
    } catch (error) {}
  }

  mobileBack() {
    this.router.navigate(['account/reward-center']);

  }

  TnCredirect(){
    if (isPlatformBrowser(this.platformId)) {
    this.localStorage.setItem('currentRoute', this.currentRoute);
    }
    this.router.navigate(['/reward-terms-condition']);

  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
